import {clearFeedbacksByName, getInputsByName} from "../../helpers/forms";
import Axios from "axios";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../helpers/loading";

/**
 *
 * @param {Element} formElement
 */
function initClientAccountForm(formElement) {
	// Init form

	// Account status toggle
	const toggleAccountStatusButton = formElement.querySelector('.toggle-account-status-button');
	if (toggleAccountStatusButton) {
		toggleAccountStatusButton.addEventListener('click', e => {
			const enabled = e.target.dataset.action;

			loading();

			Axios.post(
				window['routes/admin.client-accounts.toggle-status'],
				{
					enabled
				})
				.then(handleAjaxSuccess)
				.catch(error => {
					handleAjaxError(error, formElement)
				})
				.finally(stopLoading)
		})
	}

	// Form methods
	return {
		formElement,
		formFields: [
			'id',
			'name',
			'email',
			'phone',
			'notes',
		],
		inputs() {
			return getInputsByName(formElement, this.formFields);
		},
		clearFeedbacks() {
			return clearFeedbacksByName(formElement, this.formFields);
		},
		postRoute() {
			// noinspection JSUnresolvedVariable
			return formElement.dataset.postRoute;
		},
		submit() {
			return Axios.post(this.postRoute(), this.inputs())
		}
	};
}

export {initClientAccountForm}
